import { render, staticRenderFns } from "./PhenoSelector.vue?vue&type=template&id=462e957e&scoped=true"
import script from "./PhenoSelector.vue?vue&type=script&lang=js"
export * from "./PhenoSelector.vue?vue&type=script&lang=js"
import style0 from "./PhenoSelector.vue?vue&type=style&index=0&id=462e957e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462e957e",
  null
  
)

export default component.exports